export function authenticatedUsers() {
    return {
        restrict: 'E',
        scope: {},
        controller: AuthenticatedUsersController,
        controllerAs: 'vm',
        templateUrl: 'app/components/authenticated-users.directive.html'
    };
}

class AuthenticatedUsersController {
    /* @ngInject */
    constructor(authenticatedUserService, $state, $window, egUrlService) {
        this.authenticatedUserService = authenticatedUserService;
        this.$state = $state;
        this.userIdentifications = [];
        this.$window = $window;
        this.egUrlService = egUrlService;
        authenticatedUserService.getAuthenticatedUsers()
            .then(response => { this.userIdentifications = response; });

    }

}
